/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsDivProps } from '../Component.props';
import { FormControlOption } from '../FormFields/FormControl';
import { CheckboxRadioProps } from '../FormFields/fields/CheckboxRadio';

/**
 * The props for `<ChipFilter />`.
 */
export interface ChipFilterProps extends SdsDivProps, ChipFilterSelectProps, ChipFilterRadioProps {
  classes?: string;
  filterHeader?: string;
  simplifyRadioFilters?: boolean;
  type?: 'radio' | 'checkbox';
  checkboxListProps?: Partial<CheckboxRadioProps>;
  dataId?: string;
  filters: Array<FormControlOption>;
  icon?: JSX.Element;
  isDisabled?: boolean;
  labels?: ChipFilterLabels;
}

/**
 * The props for `<ChipFilter />` if using the default select list type.
 */
export interface ChipFilterSelectProps {
  setFilters?(filters: []): void;
  counter?: boolean;
  showClearAll?: boolean;
}

/**
 * The props for `<ChipFilter />` if using radio button list type.
 */
export interface ChipFilterRadioProps {
  badge?: boolean;
  setChosenRadioOptionHandler?(option: FormControlOption): void;
  chosenRadioOption?: string;
  confirmRadioOptionHandler?(chosenOption: string): void;
  confirmedRadioOption?: string;
}

/**
 * The labels for `<ChipFilter />`.
 */
export interface ChipFilterLabels {
  button: string;
  clearAll?: string;
  default: string;
}

// Default props for `<ChipFilter />`.
export const chipFilterDefaultProps: ChipFilterProps = {
  checkboxListProps: {},
  dataId: `chip-filter`,
  filters: [],
  labels: {
    button: `Apply`,
    clearAll: 'Clear all',
    default: `Event filter`,
  },
  setFilters: (filters): void => {
    // noop.
  },
  type: 'checkbox',
};
